export const PAYMENT_CURRENCY_CODE = 'GBP';
export const MERCHANT_NAME = 'DPD group UK';
